"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import { HeroSliderSlide } from "./HeroSliderSlide";
import { SearchInputHomePage } from "./SearchInputHomePage";

const _interactionsData = JSON.parse(
  '{"events":{"e-123":{"id":"e-123","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-41","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-124"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"65ee92366d1cabac2751eedb|416e6042-9467-0807-a1bc-bfebb5a69085","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"65ee92366d1cabac2751eedb|416e6042-9467-0807-a1bc-bfebb5a69085","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1707853020650},"e-125":{"id":"e-125","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-41","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-126"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"65ee92366d1cabac2751eedb|416e6042-9467-0807-a1bc-bfebb5a6908f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"65ee92366d1cabac2751eedb|416e6042-9467-0807-a1bc-bfebb5a6908f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1707853020650}},"actionLists":{"a-41":{"id":"a-41","title":"Hero Modal [open]","actionItemGroups":[{"actionItems":[{"id":"a-41-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".search_modal___opacity-_0-hide-me","selectorGuids":["8aace977-8e15-c119-0532-3d7cc721b5df"]},"value":"none"}},{"id":"a-41-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".search_modal___opacity-_0-hide-me","selectorGuids":["8aace977-8e15-c119-0532-3d7cc721b5df"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-41-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".search_modal___opacity-_0-hide-me","selectorGuids":["8aace977-8e15-c119-0532-3d7cc721b5df"]},"value":"flex"}},{"id":"a-41-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":500,"target":{"selector":".search_modal___opacity-_0-hide-me","selectorGuids":["8aace977-8e15-c119-0532-3d7cc721b5df"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1707139287082}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function HomeHero({
  as: _Component = _Builtin.Block,
  searchInputSlot,
  toggleSearchButtonProps = {},
}) {
  _interactions.useInteractions(_interactionsData);

  return (
    <_Component className="home-hero" tag="header">
      <_Builtin.Block className="hero-form" tag="div">
        <_Builtin.Block className="padding-global" tag="div">
          <_Builtin.Block className="hero-form_wrapper" tag="div">
            <_Builtin.Block className="div-block-91" tag="div">
              <_Builtin.Block className="margin-bottom margin-small" tag="div">
                <_Builtin.Heading className="hero-h1" tag="h1">
                  {"Uncover Your Oasis"}
                </_Builtin.Heading>
              </_Builtin.Block>
              <_Builtin.Block className="margin-bottom margin-medium" tag="div">
                <_Builtin.Block className="div-block-81" tag="div">
                  <_Builtin.Block
                    className="hero_modal-trigger-wrapper position-absolute z-index-2"
                    tag="div"
                    {...toggleSearchButtonProps}
                  />
                  <_Builtin.Link
                    className="accessibility-link position-absolute z-index-1"
                    button={false}
                    id="main-content"
                    block="inline"
                    options={{
                      href: "#",
                    }}
                  >
                    <_Builtin.Block
                      className="hero-form_form-wrapper-copy"
                      tag="div"
                    >
                      <_Builtin.Block className="fake-input" tag="div">
                        <_Builtin.Block className="fake-input-field" tag="div">
                          {"Search by location or community ..."}
                        </_Builtin.Block>
                      </_Builtin.Block>
                      <_Builtin.Block className="fake-submit-button" tag="div">
                        <_Builtin.Block className="text-block-13" tag="div">
                          {"Search"}
                        </_Builtin.Block>
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Link>
                  <_Builtin.Block
                    className="hero_modal-trigger"
                    tag="div"
                    {...toggleSearchButtonProps}
                  />
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className="text-size-large spacing-medium"
              tag="div"
            >
              {"Experience Hassle-Free Living"}
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.SliderWrapper
        className="hero-slider"
        navSpacing={3}
        navShadow={false}
        autoplay={true}
        delay={4000}
        iconArrows={true}
        animation="slide"
        navNumbers={false}
        easing="ease-in-out"
        navRound={true}
        hideArrows={false}
        disableSwipe={false}
        duration={500}
        infinite={true}
        autoMax={0}
        navInvert={false}
      >
        <_Builtin.SliderMask>
          <_Builtin.SliderSlide className="hero-slider_slide" tag="div">
            <HeroSliderSlide
              heroSliderSlideImageImage="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65cd349d1b7c583c38e7c837_1250%20Lakeside-Living%20Room%20HIGH.jpeg"
              imagePriority="high"
            />
          </_Builtin.SliderSlide>
          <_Builtin.SliderSlide className="hero-slider_slide" tag="div">
            <HeroSliderSlide
              heroSliderSlideImageImage="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65cd3325515a317880ba082a_Eastlake-Fire%20Pit%20High.jpeg"
              topTextText="Eastlake"
              bottomTextText="Seattle WA"
              imagePriority="auto"
            />
          </_Builtin.SliderSlide>
          <_Builtin.SliderSlide className="hero-slider_slide" tag="div">
            <HeroSliderSlide
              heroSliderSlideImageImage="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65cd33250bf2f46d247e66c9_Artizan-Default%20-%20high.jpeg"
              topTextText="Artizan"
              bottomTextText="Oakland ca"
              imagePriority="auto"
            />
          </_Builtin.SliderSlide>
          <_Builtin.SliderSlide className="hero-slider_slide" tag="div">
            <HeroSliderSlide
              heroSliderSlideImageImage="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65cd33254a49cdcd15276da3_Bahay-Kitchen%20High.jpeg"
              topTextText="Bahay"
              bottomTextText="Los Angeles CA"
              imagePriority="auto"
            />
          </_Builtin.SliderSlide>
        </_Builtin.SliderMask>
        <_Builtin.SliderArrow className="left-arrow-2" dir="left">
          <_Builtin.Icon
            className="icon-4"
            widget={{
              type: "icon",
              icon: "slider-left",
            }}
          />
        </_Builtin.SliderArrow>
        <_Builtin.SliderArrow className="right-arrow-2" dir="right">
          <_Builtin.Icon
            className="icon-3"
            widget={{
              type: "icon",
              icon: "slider-right",
            }}
          />
        </_Builtin.SliderArrow>
        <_Builtin.SliderNav className="slide-nav" />
      </_Builtin.SliderWrapper>
      <_Builtin.Block
        className="search_modal___opacity-_0-hide-me"
        tag="div"
        role="dialog"
      >
        <_Builtin.Block
          className="search_modal-close-button"
          tag="div"
          {...toggleSearchButtonProps}
        >
          <_Builtin.HtmlEmbed
            className="html-embed-4"
            value="%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20512%20512%22%3E%3Cpath%20fill%3D%22currentColor%22%20d%3D%22M256%20512A256%20256%200%201%200%20256%200a256%20256%200%201%200%200%20512zM175%20175c9.4-9.4%2024.6-9.4%2033.9%200l47%2047%2047-47c9.4-9.4%2024.6-9.4%2033.9%200s9.4%2024.6%200%2033.9l-47%2047%2047%2047c9.4%209.4%209.4%2024.6%200%2033.9s-24.6%209.4-33.9%200l-47-47-47%2047c-9.4%209.4-24.6%209.4-33.9%200s-9.4-24.6%200-33.9l47-47-47-47c-9.4-9.4-9.4-24.6%200-33.9z%22%2F%3E%3C%2Fsvg%3E"
          />
        </_Builtin.Block>
        <_Builtin.Block
          className="search_modal-close-trigger"
          tag="div"
          tabIndex="-1"
          aria-hidden="true"
          {...toggleSearchButtonProps}
        />
        <_Builtin.Block className="search-modal-slot-container" tag="div">
          {searchInputSlot ?? (
            <_Builtin.Block className="search-modal-input-container" tag="div">
              <SearchInputHomePage showPopover={true} showClear={true} />
            </_Builtin.Block>
          )}
        </_Builtin.Block>
        <_Builtin.Link
          className="search-modal-close-button"
          button={false}
          block="inline"
          options={{
            href: "#",
          }}
          {...toggleSearchButtonProps}
        >
          <_Builtin.Block className="div-block-106" tag="div">
            <_Builtin.HtmlEmbed
              className="search-modal-close-icon"
              value="%3C!--%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20512%20512%22%3E%3Cpath%20fill%3D%22currentColor%22%20d%3D%22M256%20512A256%20256%200%201%200%20256%200a256%20256%200%201%200%200%20512zM175%20175c9.4-9.4%2024.6-9.4%2033.9%200l47%2047%2047-47c9.4-9.4%2024.6-9.4%2033.9%200s9.4%2024.6%200%2033.9l-47%2047%2047%2047c9.4%209.4%209.4%2024.6%200%2033.9s-24.6%209.4-33.9%200l-47-47-47%2047c-9.4%209.4-24.6%209.4-33.9%200s-9.4-24.6%200-33.9l47-47-47-47c-9.4-9.4-9.4-24.6%200-33.9z%22%2F%3E%3C%2Fsvg%3E%0A--%3E%0A%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20384%20512%22%3E%0A%20%20%3Cpath%20fill%3D%22currentColor%22%20d%3D%22M345%20137l17-17L328%2086.1l-17%2017-119%20119L73%20103l-17-17L22.1%20120l17%2017%20119%20119L39%20375l-17%2017L56%20425.9l17-17%20119-119L311%20409l17%2017L361.9%20392l-17-17-119-119L345%20137z%22%2F%3E%3C%2Fsvg%3E"
            />
            <_Builtin.Block className="text-block-15" tag="div">
              {"Close"}
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Link>
      </_Builtin.Block>
    </_Component>
  );
}
